import i18n from "./index";

// BCP-47 locale per app language (Quebec FR, Canadian EN, generic ES)
const LOCALE_MAP = { fr: "fr-CA", en: "en-CA", es: "es" };

let _currency = (localStorage.getItem("pp_currency") || "CAD").toUpperCase();

export function setCurrency(cur) {
  if (cur) {
    _currency = cur.toUpperCase();
    localStorage.setItem("pp_currency", _currency);
    // Force react-i18next consumers to re-render so formatted amounts update live.
    try { i18n.emit("languageChanged", i18n.language); } catch (e) { /* noop */ }
  }
}

export function getCurrency() {
  return _currency;
}

function locale() {
  return LOCALE_MAP[i18n.language] || "fr-CA";
}

export function formatCurrency(amount, currency) {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(locale(), { style: "currency", currency: (currency || _currency) }).format(n);
  } catch (e) {
    return `${n.toFixed(2)} ${currency || _currency}`;
  }
}

// Plan prices: show explicit ISO code (CAD/USD) with no decimals, no duplicated symbol.
export function formatPlanPrice(amount, currency) {
  const n = Number(amount || 0);
  const cur = (currency || _currency).toUpperCase();
  try {
    return new Intl.NumberFormat(locale(), { style: "currency", currency: cur, currencyDisplay: "code", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
  } catch (e) {
    return `${Math.round(n)} ${cur}`;
  }
}

export function formatNumber(n, opts = {}) {
  try {
    return new Intl.NumberFormat(locale(), opts).format(Number(n || 0));
  } catch (e) {
    return String(n);
  }
}

export function formatDate(value, opts = { year: "numeric", month: "short", day: "numeric" }) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return String(value);
  try {
    return new Intl.DateTimeFormat(locale(), opts).format(d);
  } catch (e) {
    return d.toLocaleDateString();
  }
}

export function formatDateTime(value) {
  return formatDate(value, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}
